import { ILogger } from '../logger/ilogger';
import { LoggerService } from '../logger/logger.service';

export enum StorageType {
  Local,
  Session,
}

export abstract class StorageServiceBase {
  private storageLogger: ILogger;

  constructor(
    logService: LoggerService,
    private storage: any,
  ) {
    this.storageLogger = logService.getLogger('Storage');
  }

  public setString(key: string, val: string): void {
    // this.storageLogger.log("'" + key + 'set to string:' + val, this.serviceName);
    this.storage.setItem(key, val);
  }

  public getString(key: string): string {
    let data = this.storage.getItem(key);
    // this.storageLogger.log("'" + key + "' get string : " + data, this.serviceName);
    return data;
  }

  public setObject(key: string, val: any): void {
    //this.storageLogger.log("'" + key + "' set to object: " + JSON.stringify(val), val, this.serviceName);
    this.storage.setItem(key, JSON.stringify(val));
  }

  public getObject<T>(key: string): T {
    let data = this.storage.getItem(key);
    //this.storageLogger.log("'" + key + "' get object : ", data, this.serviceName);
    if (data === null || data === undefined) {
      return null as T;
    }

    return JSON.parse(data) as T;
  }

  public clearItem(key: string): void {
    //this.storageLogger.log("Clear key : '" + key + "'", this.serviceName);
    this.storage.removeItem(key);
  }

  public clear() {
    this.storage.clear();
  }

  /** List helpers */
  public addToList(
    key: string,
    itemToAdd: any,
    preventDuplicate: boolean = false,
  ) {
    //this.storageLogger.log(`Adding item ${itemToAdd} in key item ${key}`);
    let existing: any[] = this.getObject<any[]>(key);
    if (existing) {
      if (!preventDuplicate || existing.indexOf(itemToAdd) === -1) {
        existing.push(itemToAdd);
        this.setObject(key, existing);
      }
    } else {
      this.setObject(key, [itemToAdd]);
    }
  }

  public deleteFromList(key: string, itemToDelete: any) {
    this.storageLogger.log(`Deleting item ${itemToDelete} in key item ${key}`);
    let existing: any[] = this.getObject<any[]>(key);
    if (existing) {
      let index = existing.indexOf(itemToDelete);
      existing.splice(index, 1);
      this.setObject(key, existing);
    }
  }
}
